module.exports = __webpack_public_path__ + "static/media/NathanDrake.2e0d9d7c.png";